export const getGamePlayerLabel = (displayName?: string | null, email?: string | null) => {
  const safeDisplayName = displayName?.trim();
  if (safeDisplayName && !/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(safeDisplayName)) {
    return safeDisplayName;
  }

  const safeEmail = email?.trim();
  if (safeEmail) {
    return safeEmail;
  }

  return "Player";
};
